import type { ResolvedTheme } from './theme.interface';

const setCssVar = (name: string, value: string | number) => {
    document.documentElement.style.setProperty(name, String(value));
};

const applyColorGroup = (
    groupName: string,
    group?: Partial<Record<number, string>>,
) => {
    if (!group) return;
    Object.entries(group).forEach(([key, value]) => {
        if (value === undefined) return;
        const suffix = key === '0' ? '' : `-${key}`;
        setCssVar(`--color-${groupName}${suffix}`, value);
    });
};

export const applyCssVariables = (theme: ResolvedTheme) => {
    applyColorGroup('primary', theme.brand.primary);
    applyColorGroup('green', theme.brand.green);
    applyColorGroup('dark', theme.brand.dark);
    applyColorGroup('white', theme.brand.white);
    applyColorGroup('yellow', theme.brand.yellow);
    applyColorGroup('orange', theme.brand.orange);
    applyColorGroup('blue', theme.brand.blue);
    applyColorGroup('purple', theme.brand.purple);
    applyColorGroup('red', theme.brand.red);
    applyColorGroup('neutral', theme.brand.neutral);
    applyColorGroup('gray', theme.brand.gray);

    setCssVar('--border-radius-sm', `${theme.brand.radius.sm}px`);
    setCssVar('--border-radius-md', `${theme.brand.radius.md}px`);
    setCssVar('--border-radius-lg', `${theme.brand.radius.lg}px`);
    setCssVar('--border-radius-xl', `${theme.brand.radius.xl}px`);

    setCssVar('--padding-none', `${theme.brand.padding.none}px`);
    setCssVar('--padding-sm', `${theme.brand.padding.sm}px`);
    setCssVar('--padding-md', `${theme.brand.padding.md}px`);
    setCssVar('--padding-lg', `${theme.brand.padding.lg}px`);
    setCssVar('--padding-xl', `${theme.brand.padding.xl}px`);

    setCssVar('--margin-none', `${theme.brand.margin.none}px`);
    setCssVar('--margin-sm', `${theme.brand.margin.sm}px`);
    setCssVar('--margin-md', `${theme.brand.margin.md}px`);
    setCssVar('--margin-lg', `${theme.brand.margin.lg}px`);
    setCssVar('--margin-xl', `${theme.brand.margin.xl}px`);

    setCssVar('--font-family', theme.brand.fontFamily);
    setCssVar('--mode', theme.mode);
    setCssVar('--full-width', '100%');

    const isDark = theme.mode === 'dark';
    setCssVar('--bg-body', isDark ? '#141414' : '#fff');
    setCssVar('--bg-container', isDark ? '#1f1f1f' : '#fff');
    setCssVar('--bg-elevated', isDark ? '#2a2a2a' : '#F2F8FF');
    setCssVar('--bg-hover', isDark ? '#3a3a3a' : '#E1E8F1');
    setCssVar('--text-primary', isDark ? '#e5e5e5' : '#3F4D70');
    setCssVar('--text-secondary', isDark ? '#a3a3a3' : '#687385');
    setCssVar('--border-color', isDark ? '#424242' : '#EBEEF1');
    setCssVar('--sidebar-active', '#6C8EEF');
};
